module.exports = __webpack_public_path__ + "static/media/tracy_01.f0d5d549.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/album/tracy_01.jpg
// module id = 379
// module chunks = 0